import StoreApplicationState from "@store/Store/StoreApplicationState";

export const getFieldValue = (state: StoreApplicationState, key: string) => {
    return state.store.pages.createAccountForm.fieldValues[key];
};
